import React from "react";

import CssBaseline from "@mui/material/CssBaseline";
import {
  createTheme, StyledEngineProvider, ThemeProvider
} from "@mui/material/styles";
import { styled } from '@mui/styles';

import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import ApplicationBar from "./ApplicationBar";
import About from "./About";
import EnglandModel from "./EnglandModel";
import PageFooter from "./PageFooter";
import UkModel from "./UkModel";

import { muiTheme } from "./app-theme.config";

// create our material ui theme using up to date typography variables
const appTheme = createTheme(muiTheme);

const BodyStyled = styled("div")(({ theme }) => ({

  // Fix IE11 issue.
  display: "block",

  marginTop: theme.spacing(18),
  marginBottom: theme.spacing(4),
  width: 1024,
  marginLeft: "auto",
  marginRight: "auto",

  [theme.breakpoints.up(1024 + theme.spacing(3) * 2)]: {
    width: 1024,
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

const Body = () => {
  return (
    <BodyStyled>
      <BrowserRouter>
        <Routes>
          <Route path="/uk" element={<UkModel />} />
          <Route path="/eng" element={<EnglandModel />} />
          <Route path="/about" element={<About />} />
          <Route path="/" element={<Navigate to="/uk" />} />
        </Routes>
      </BrowserRouter>
    </BodyStyled>
  )
};

const App = () => (
  <>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <ApplicationBar />
        <Body />
        <PageFooter />
      </ThemeProvider>
    </StyledEngineProvider>
  </>
);

export default App;
